import { useCallback } from 'react';
import { useQueryClient } from '@common-fe/common-fe';

import { API_URL } from '@/dtos';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const useInvalidateLockbox = (lockboxId?: string) => {
  const queryClient = useQueryClient();
  const { setEditableLockbox } = useLockboxDetailsStore();

  const invalidateLockbox = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: [API_URL.LOCKBOXES_BY_LOCKBOX_ID(lockboxId || '')],
    });
    setEditableLockbox({ isUpdated: false });
  }, [queryClient, setEditableLockbox, lockboxId]);

  return invalidateLockbox;
};

export default useInvalidateLockbox;
